import { Component, OnInit } from '@angular/core';
import { Achievements } from '../../models/achievement';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-achievement-details',
  templateUrl: './achievement-details.component.html',
  styleUrls: ['./achievement-details.component.scss']
})
export class AchievementDetailsComponent implements OnInit {

  model = {} as Achievements;
  constructor(
    private route: Router,
    private diag: NbDialogRef<AchievementDetailsComponent>,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

}
